import { unmappedDeviceListQuerySchema, type UnmappedDevice } from '@chukua/common';
import { useEffect, useState } from 'react';
import { listUnmappedDevices } from '../gps.api';

export type UnmappedDevicesState = { status: 'loading' } | { status: 'loaded'; devices: UnmappedDevice[]; total: number } | { status: 'error' };

/** How many unmapped devices the panel lists before it says how many more there are. */
const SHOWN = 10;

/** The devices this integration hears from that no truck owns, the most recent first. */
export function useUnmappedDevices(integrationId: string): UnmappedDevicesState {
  const [state, setState] = useState<UnmappedDevicesState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    listUnmappedDevices({ ...unmappedDeviceListQuerySchema.parse({ pageSize: SHOWN }), integrationId: [integrationId] })
      .then((page) => !cancelled && setState({ status: 'loaded', devices: page.items, total: page.total }))
      .catch(() => !cancelled && setState({ status: 'error' }));
    return () => {
      cancelled = true;
    };
  }, [integrationId]);

  return state;
}
